import FormField from 'Components/FormComponents/FormField';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as SearchIcon} from 'assets/icons/search.svg';
import {ReactComponent as FiltersIcon} from 'assets/icons/filters.svg';
import {ReactComponent as Pattern} from 'assets/images/search-header-icon.svg';
import {useIntl} from 'react-intl';
import {useEffect, useRef} from 'react';
import '@algolia/autocomplete-theme-classic';
import {autocomplete, getAlgoliaResults} from '@algolia/autocomplete-js';
import algoliasearch from "algoliasearch/lite";

const SearchHeader = ({
                        formConfig,
                        searchCallback,
                        formState,
                        setFormState,
                        setFiltersState,
                        title,
                        searchButton,
                        indexName
                      }) => {
  const intl = useIntl();
  const autocompleteContainerRef = useRef(null);
  const buttonRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    // Initialize Algolia client
    const searchClient = algoliasearch(
      process.env.REACT_APP_ALGOLIA_APP_ID,
      process.env.REACT_APP_ALGOLIA_API_KEY
    );

    // Initialize Autocomplete
    const search = autocomplete({
      container: autocompleteContainerRef.current,
      placeholder: intl.formatMessage({id: 'ProgramFinder.Query.Placeholder'}),
      openOnFocus: true,
      initialState: {
        query: formState?.query || '',
      },
      getSources() {
        return [
          {
            sourceId: 'destinations',
            getItemInputValue: ({item}) => item.title,
            getItems({query}) {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: indexName,
                    params: {
                      query,
                      hitsPerPage: 8,
                    },
                  },
                ],
              });
            },
            templates: {
              item({item}) {
                return item.title;
              },
            },
          },
        ];
      },
      onStateChange({state}) {
        setFormState({
          query: state.query,
        });
      },
      onSubmit({state}) {
        if (state.query) {
          // eslint-disable-next-line no-undef
          Drupal.behaviors.view_search_results.pushEvent(state.query);
        }
        setFormState({
          query: state.query,
        });

        buttonRef.current.click();
      },
    });

    // Store the autocomplete instance
    autocompleteRef.current = search;

    return () => {
      search.destroy();
    };
  }, []);

  // Update autocomplete when formState.query changes externally (e.g., from Clear Filters)
  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.setQuery(formState?.query || '');
    }
  }, [formState?.query]);

  return (
    <>
      <div className="search-header">
        <div className="container">
          <h1 className='program-finder-header__title'>
            {intl.formatMessage({id: title})}
          </h1>

          <div className="flex flex-col md:flex-row lg:w-full gap-10 search-header__form-wrapper">
            <div className="flex flex-grow search-header__form">
              <div ref={autocompleteContainerRef}/>

              <FormField
                fieldConfig={formConfig}
                state={formState}
                setState={setFormState}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    if (formState?.query) {
                      // eslint-disable-next-line no-undef
                      Drupal.behaviors.view_search_results.pushEvent(formState.query);
                    }
                    searchCallback(true);
                  }
                }}
                searchCallback={() => {
                  searchCallback(true)
                }}
              />
              <button className="button search-header__search-button items-center" ref={buttonRef}
                      onClick={() => {
                        if (formState?.query) {
                          // eslint-disable-next-line no-undef
                          Drupal.behaviors.view_search_results.pushEvent(formState.query);
                        }
                        searchCallback();
                      }}>
                <div className="flex items-center" aria-hidden={true}>
                  <SearchIcon/>
                </div>
                <span className="visually-hidden">{intl.formatMessage({id: searchButton})}</span>
              </button>

            </div>

            <Pattern className="search-header__pattern"/>
          </div>
        </div>
      </div>

      <div className="lg:hidden mb-20">
        <Button buttonClasses="button--full-width button--filters" onClick={() => setFiltersState(true)}>
          <h3>
            {intl.formatMessage({id: 'Algolia.SearchPage.Filters.Label'})}
          </h3>
          <FiltersIcon/>
        </Button>
      </div>
    </>
  )
}

export default SearchHeader;
